module.exports = __webpack_public_path__ + "img/01bad9b93ba084a133af05236f5fc575.png";